import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DashboardMultiStationComponent } from "./components/dashboard-multistation.component";
import { AuthguardService } from "../master/services";

export const DashboardMultiStationRoutes: Routes = [
	{
		path: "",
		data: {
			title: "Dashboard (MultiStation)",
			applicationItemID: "75090a21-9f2b-4a15-bd7f-6c720d669174",
		},
		component: DashboardMultiStationComponent,
		// canActivate: [AuthguardService],
	},
];
